module.exports = __webpack_public_path__ + "img/1483594858.5331983d.jpg";